import { vuexfireMutations, firestoreAction } from "vuexfire";
import { equipmentsCollection } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    equipments: [],
    equipmentProfile: {}
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    callEquipments: context => {
      context.dispatch("bindEquipments");
    },
    bindEquipments: firestoreAction(context => {
      return context.bindFirestoreRef(
        "equipments",
        equipmentsCollection.where("disabled", "==", false)
      );
    }),
    bindAnEquipment: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "equipmentProfile",
        equipmentsCollection.doc(id)
      );
    })
  },
  getters: {
    equipmentsList: (state, getters, rootState) => {
      let result;
      if (!rootState.auth.user?.isMetax) {
        result = state.equipments?.filter(
          data => data.plant?.name === rootState.auth?.user?.plant
        );
      } else {
        result = state.equipments;
      }
      return result;
    }
  }
};
